import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Routess } from "../../Routes/routes";
import { sendError, sendSuccess } from "../../helpers/Helper";
import axios from "axios";
import { FormProvider, useForm } from "react-hook-form";
import { useAuth } from "../../store/AuthContext";
import { API_URL_ENDPOINT } from "../../appsetting";
import { Textbox } from "../../components/Textbox";

export const Forgot = () => {
  const [successMessage, setSuccessMessage] = useState("");

  const { login } = useAuth();
  const navigate = useNavigate();

  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
  } = methods;

  const onSubmit = async (param) => {
    try {
      const response = await axios.post(
        API_URL_ENDPOINT.ForgotPassword,
        param,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data?.status) {
        setSuccessMessage(
          response.data?.message ??
            "A reset link has been sent to your email. Please check your inbox."
        );
        reset();
        sendSuccess(response.data?.message);
      } else {
        sendError(response.data?.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(
        ex.response?.data?.message || ex.message || "Something went wrong"
      );
    }
  };
  return (
    <main>
      <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link
                as={Link}
                to={Routess.Login.path}
                className="text-gray-700"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to
                Log In
              </Card.Link>
            </p>
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                {successMessage ? (
                  <div className="text-center mt-4">
                    <div className="alert alert-success border-0 shadow-sm">
                      <h5 className="mb-2">✅ Reset Link Sent</h5>
                      <p className="mb-0">{successMessage}</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <h3>Forgot your password?</h3>
                    <p className="mb-4">
                      Don't fret! Just type in your email and we will send you a
                      link to reset your password!
                    </p>
                    <FormProvider {...methods}>
                      <Form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group id="email-group" className="mb-3">
                          <Textbox
                            Label="Your Email"
                            name="email"
                            Placeholder="Enter Your Email"
                            validationRules={{
                              required: "Email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // simple email regex
                                message: "Enter a valid email address",
                              },
                            }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                        <Button
                          variant="primary"
                          disabled={isSubmitting}
                          type="submit"
                          className="w-100"
                        >
                          {isSubmitting ? "Please Wait..." : "Recover Account"}
                        </Button>
                      </Form>
                    </FormProvider>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
